/*
  COTANTIN ポリシーページ（sections/cotantin-policy-head.liquid）。本文は Shopify の rich text なので、見た目のための手当てをここでする。
  - 空の段落（改行や空白だけ）を隠す。章見出し h2 の「1．」「1.」を番号として分ける。h3 の先頭の全角空白を外す
  - h2 が 3 つ以上あれば目次を作る：PC は本文の左に追従、スマホは本文の前に折りたたみ。現在地はスクロール位置で判定
    （見出しが画面の上から 30% の線より上にある最後の章。FAQ と同じ）
  本文の文字そのものは変えない（番号の区切りの「．」を「.」で表示するだけ）。
*/
(function () {
  function firstText(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.replace(/[\s 　]/g, '') !== '') return node;
    }
    return null;
  }

  function init() {
    var page = document.querySelector('.cp-page');
    var body = page && page.querySelector('.shopify-policy__body');
    if (!body) return;
    var rte = body.querySelector('.rte') || body;

    Array.prototype.forEach.call(rte.querySelectorAll('p, ul, ol'), function (el) {
      if (el.textContent.replace(/[\s 　]/g, '') === '' && !el.querySelector('img, iframe, video, table')) {
        el.classList.add('cp-empty');
      }
    });

    Array.prototype.forEach.call(rte.querySelectorAll('h3'), function (h) {
      var t = firstText(h);
      if (t) t.nodeValue = t.nodeValue.replace(/^[\s 　]+/, '');
    });

    var heads = Array.prototype.filter.call(rte.querySelectorAll('h2'), function (h) {
      return h.textContent.replace(/[\s 　]/g, '') !== '';
    });
    var items = heads.map(function (h, i) {
      var num = '';
      var t = firstText(h);
      if (t) {
        var m = t.nodeValue.match(/^[\s 　]*(\d+)\s*[.．]\s*/);
        if (m) {
          num = m[1];
          t.nodeValue = t.nodeValue.slice(m[0].length);
        }
      }
      var rest = document.createElement('span');
      while (h.firstChild) rest.appendChild(h.firstChild);
      if (num) {
        var n = document.createElement('span');
        n.className = 'cp-num';
        n.setAttribute('lang', 'en');
        n.textContent = num + '.';
        h.appendChild(n);
      }
      h.appendChild(rest);
      if (!h.id) h.id = 'cp-' + (num || 'h' + (i + 1));
      return { el: h, num: num, label: rest.textContent.replace(/\s+/g, ' ').trim() };
    });

    if (items.length < 3) return;

    var nav = page.querySelector('.cp-nav');
    var tocLabel = (nav && nav.getAttribute('data-cp-toc-label')) || '';

    function links(listClass) {
      var list = document.createElement('div');
      list.className = listClass;
      items.forEach(function (item) {
        var a = document.createElement('a');
        a.className = 'cp-toc__link';
        a.href = '#' + item.el.id;
        a.setAttribute('data-cp-link', item.el.id);
        if (item.num) {
          var n = document.createElement('span');
          n.className = 'cp-toc__num';
          n.setAttribute('lang', 'en');
          n.textContent = item.num;
          a.appendChild(n);
        }
        a.appendChild(document.createTextNode(item.label));
        list.appendChild(a);
      });
      return list;
    }

    // PC：左に追従する目次
    var pc = document.createElement('nav');
    pc.className = 'cp-toc-pc';
    if (tocLabel) pc.setAttribute('aria-label', tocLabel);
    if (tocLabel) {
      var label = document.createElement('p');
      label.className = 'cp-toc__label';
      label.textContent = tocLabel;
      pc.appendChild(label);
    }
    pc.appendChild(links('cp-toc-pc__list'));

    // スマホ：本文の前に折りたたみ
    var m = document.createElement('details');
    m.className = 'cp-toc-m';
    var summary = document.createElement('summary');
    summary.className = 'cp-toc-m__summary';
    summary.appendChild(document.createTextNode(tocLabel));
    var icon = document.createElement('span');
    icon.className = 'cp-toc-m__icon';
    icon.setAttribute('aria-hidden', 'true');
    summary.appendChild(icon);
    m.appendChild(summary);
    m.appendChild(links('cp-toc-m__list'));

    var wrap = document.createElement('div');
    wrap.className = 'cp-toc';
    wrap.appendChild(pc);
    body.insertBefore(wrap, body.firstChild);
    rte.parentNode.insertBefore(m, rte);
    // PC のグリッドは「目次｜本文」の 2 列。スマホの目次は本文の列に入れる
    var main = document.createElement('div');
    main.className = 'cp-body';
    rte.parentNode.insertBefore(main, m);
    main.appendChild(m);
    main.appendChild(rte);
    body.classList.add('cp-has-toc');

    var tocLinks = Array.prototype.slice.call(page.querySelectorAll('[data-cp-link]'));
    var current = null;
    var ticking = false;
    function setCurrent(id) {
      if (id === current) return;
      current = id;
      tocLinks.forEach(function (a) {
        var on = a.getAttribute('data-cp-link') === id;
        a.classList.toggle('is-current', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    }
    function update() {
      ticking = false;
      var line = window.innerHeight * 0.3;
      var id = items[0].el.id;
      for (var i = 0; i < items.length; i++) {
        if (items[i].el.getBoundingClientRect().top <= line) id = items[i].el.id; else break;
      }
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
        var last = items[items.length - 1].el;
        if (last.getBoundingClientRect().top < window.innerHeight) id = last.id;
      }
      setCurrent(id);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();

    tocLinks.forEach(function (a) {
      a.addEventListener('click', function (event) {
        var target = document.getElementById(a.getAttribute('data-cp-link'));
        if (!target) return;
        event.preventDefault();
        if (m.contains(a)) m.open = false;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + target.id);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
